import { useTranslation } from 'react-i18next';

interface IProps {
  labelId: string;
  defaultMessage?: string;
}

export default function I18nLabel(props: IProps): JSX.Element {
  const { t } = useTranslation('default');

  const { labelId, defaultMessage } = props;
  return t(labelId, defaultMessage || labelId);
}
